export const lazyLoad = (view) => {
  // eslint-disable-next-line
  return () => import('@/' + view + '.vue')
}
